// Central mapping of extra category IDs to display labels
// Keep labels as product-facing strings (no auto-capitalization in components)

export const CATEGORY_LABELS: Record<string, string> = {
    // PRODUCT
    FOOD_DRINKS: "Food & drinks",
    CLOTHING: "Clothing",
    ELECTRONICS: "Electronics",
    HOME_DECOR: "Home decor",
    BEAUTY: "Beauty & personal care",
    SPORTS: "Sports & fitness",
    BOOKS: "Books & media",
    TOYS: "Toys & games",
    HEALTH: "Health & wellness",
    OTHER_PRODUCTS: "Other products",

    // SERVICE
    CLEANING: "Cleaning services",
    CONCIERGE: "Concierge services",
    TECHNICAL: "Technical support",
    TRANSLATION: "Translation services",
    PHOTOGRAPHY: "Photography",
    BEAUTY_SERVICES: "Beauty services",
    FITNESS: "Fitness & training",
    TUTORING: "Tutoring & education",
    OTHER_SERVICES: "Other services",

    // ACTIVITY
    OUTDOOR_ADVENTURE: "Outdoor adventure",
    WATER_SPORTS: "Water sports",
    CULTURAL: "Cultural activities",
    ENTERTAINMENT: "Entertainment",
    COOKING: "Cooking & culinary",
    WELLNESS: "Wellness & relaxation",
    TEAM_BUILDING: "Team building",
    OTHER_ACTIVITIES: "Other activities",

    // DAYTOUR
    CITY_TOUR: "City tours",
    NATURE_TOUR: "Nature tours",
    HISTORICAL: "Historical tours",
    FOOD_TOUR: "Food tours",
    ADVENTURE_TOUR: "Adventure tours",
    PHOTOGRAPHY_TOUR: "Photography tours",
    OTHER_DAYTOURS: "Other day tours",

    // MULTIDAYTOUR
    CULTURAL_EXPEDITION: "Cultural expeditions",
    ADVENTURE_EXPEDITION: "Adventure expeditions",
    FOOD_JOURNEY: "Food journeys",
    NATURE_EXPEDITION: "Nature expeditions",
    HISTORICAL_JOURNEY: "Historical journeys",
    OTHER_MULTIDAY: "Other multi-day tours",

    // PRIVATE_TOUR
    LUXURY_PRIVATE: "Luxury private tours",
    CUSTOM_PRIVATE: "Custom private tours",
    FAMILY_PRIVATE: "Family private tours",
    ROMANTIC_PRIVATE: "Romantic private tours",
    OTHER_PRIVATE: "Other private tours",

    // TICKET
    EVENT_TICKETS: "Event tickets",
    MUSEUM_TICKETS: "Museum tickets",
    ATTRACTION_TICKETS: "Attraction tickets",
    SPORTS_TICKETS: "Sports tickets",
    TRANSPORT_TICKETS: "Transport tickets",
    OTHER_TICKETS: "Other tickets",

    // RENTAL
    VEHICLE_RENTAL: "Vehicle rental",
    EQUIPMENT_RENTAL: "Equipment rental",
    SPORTS_RENTAL: "Sports equipment",
    ELECTRONIC_RENTAL: "Electronic rental",
    PARTY_RENTAL: "Party rental",
    OTHER_RENTALS: "Other rentals",

    // CHARTER
    BOAT_CHARTER: "Boat charter",
    HELICOPTER_CHARTER: "Helicopter charter",
    LUXURY_CHARTER: "Luxury charter",
    GROUP_CHARTER: "Group charter",
    OTHER_CHARTERS: "Other charters",

    // TRANSFER
    AIRPORT_TRANSFER: "Airport transfer",
    CITY_TRANSFER: "City transfer",
    HOTEL_TRANSFER: "Hotel transfer",
    SHARED_TRANSFER: "Shared transfer",
    LUXURY_TRANSFER: "Luxury transfer",
    OTHER_TRANSFERS: "Other transfers",

    // EVENT
    WEDDING_EVENT: "Wedding events",
    BIRTHDAY_EVENT: "Birthday events",
    CORPORATE_EVENT: "Corporate events",
    HOLIDAY_EVENT: "Holiday events",
    OTHER_EVENTS: "Other events",

    // GIFT_CARD
    RETAIL_GIFT_CARD: "Retail gift cards",
    EXPERIENCE_GIFT_CARD: "Experience gift cards",
    DIGITAL_GIFT_CARD: "Digital gift cards",
    OTHER_GIFT_CARDS: "Other gift cards",

    // LESSON
    LANGUAGE_LESSON: "Language lessons",
    MUSIC_LESSON: "Music lessons",
    ART_LESSON: "Art lessons",
    COOKING_LESSON: "Cooking lessons",
    SPORTS_LESSON: "Sports lessons",
    OTHER_LESSONS: "Other lessons",

    // MERCHANDISE
    BRANDED_MERCH: "Branded merchandise",
    LOCAL_MERCH: "Local merchandise",
    CUSTOM_MERCH: "Custom merchandise",
    OTHER_MERCHANDISE: "Other merchandise",

    // CUSTOM
    PERSONALIZED: "Personalized services",
    BESPOKE: "Bespoke services",
    OTHER_CUSTOM: "Other custom",
};

export function getCategoryLabel(id?: string): string {
    if (!id) return "";
    return CATEGORY_LABELS[id] || "";
}


